/**
 * On Range Iron Play Reducers
 */
import {
    ORTIRON_ACTION,
    ALL_ORTIRON,
    ADD_ORTIRON,
    FETCH_ORTIRON,
    EDIT_ORTIRON,
    DELETE_ORTIRON,
    FETCH_ORTIRONCHART,
    FETCH_ORTIRONSHOTCHART,
 } from 'Actions/types';
 
 
 const INIT_STATE = {
    ortironlist:[],
    particularortiron:[],    
    ortironchart:[],
    ortironshotchart:[], 
    loading: false,
 };
 
 export default (state = INIT_STATE, action) => {
     switch (action.type) {
         
        case ORTIRON_ACTION:
            return { ...state, loading: true };       

        case ALL_ORTIRON:
            return { ...state, loading: false, ortironlist: action.payload };     
            
        case ADD_ORTIRON:
            return { ...state, loading: false };     
         
        case FETCH_ORTIRON:
            return { ...state, loading: false, particularortiron: action.payload };  
            
        case EDIT_ORTIRON:
            return { ...state, loading: false }; 
            
        case DELETE_ORTIRON:
            return { ...state, loading: false };     

        case FETCH_ORTIRONCHART:
            return { ...state, loading: false, ortironchart: action.payload }; 

        case FETCH_ORTIRONSHOTCHART:
            return { ...state, loading: false, ortironshotchart: action.payload };
        
        default: return { ...state };

     }
 }